import React from 'react';
import { useTranslation } from 'react-i18next';

const APP_STORE_URL = 'https://apps.apple.com/us/app/al-mazad-al-maftouh/id6780229882';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.dd.mazad';

const badgeBase =
  'inline-flex h-10 items-center gap-2 rounded-lg border border-white/20 bg-black/75 px-3 text-white shadow-md backdrop-blur-sm transition hover:bg-black/90 hover:shadow-lg sm:h-11 sm:px-3.5';

const AppDownloadBadges: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { t } = useTranslation('common');

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`.trim()} role="group" aria-label={t('home.downloadApp')}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={badgeBase}
        aria-label={t('home.downloadAppStore')}
      >
        <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
        <span className="flex flex-col items-start leading-none">
          <span className="text-[9px] uppercase tracking-wide opacity-80">Download on the</span>
          <span className="text-sm font-semibold">App Store</span>
        </span>
      </a>
      <a
        href={GOOGLE_PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={badgeBase}
        aria-label={t('home.downloadGooglePlay')}
      >
        <svg className="h-5 w-5 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M3.609 1.814L13.792 12 3.61 22.186a1.403 1.403 0 0 1-.148-.253V1.814c.05-.09.098-.175.147-.253zm1.47.99l8.776 8.776-2.47 2.47L3.61 2.804l1.47-.001zm-.001 18.392l6.295-6.295 2.47 2.47-8.765 3.825zM14.89 12.89l2.89-2.89 4.01 2.31c.76.44.76 1.54 0 1.98l-4.01 2.31-2.89-2.89 2.47-2.47-2.47-2.34z" />
        </svg>
        <span className="flex flex-col items-start leading-none">
          <span className="text-[9px] uppercase tracking-wide opacity-80">Get it on</span>
          <span className="text-sm font-semibold">Google Play</span>
        </span>
      </a>
    </div>
  );
};

export default AppDownloadBadges;
